<template>
    <div>
      <div class=" tasks-title-box w-100 rounded pa-2">
        <v-row class="px-5">
          <v-col class="my-auto"><h2>لیست کارها</h2></v-col>
          <v-col cols="12" md="3" sm="6" xs="12" class="my-auto text-center" style="max-width: 17rem">
            <v-card class="mx-auto " outlined dark color="#DC3545">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class=" text-white yekan-font">
                    <h2>
                      کارهای امروز :
                      {{tasks_count.today_task_count}}
                    </h2>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" xs="12" class="my-auto text-center" style="max-width: 17rem">
            <v-card class="mx-auto " outlined dark color="#FFC107">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class=" text-white yekan-font">
                    <h2>
                      کارهای دیروز :
                    {{tasks_count.yesterday_task_count}}
                    </h2>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col class="my-auto">
            <div class="w-100">
              <v-text-field label="جست و جو کنید"
                            placeholder="حداقل ۳ حرف "
                            dense outlined dir="ltr"
                            v-model="search_tasks"
                            class="search-tasks mr-auto py-3"
                            clearable
                            @click:clear="$emit('clear')"
                            @keydown.enter="$emit('search_by_title', search_tasks)"
                            :rules="[rules.min_3]"
                            style="margin-bottom: -25px;max-width: 200px;"
              >
                <template v-slot:append v-if="search_tasks && search_tasks.length>=3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="red" v-bind="attrs" v-on="on" @click="$emit('search_by_title', search_tasks)"> mdi-magnify </v-icon>
                    </template>
                    <span>
                    برای جست و جو کلیک کنید.
                  </span>
                  </v-tooltip>
                </template>
              </v-text-field>

            </div>
          </v-col>
        </v-row>
      </div>
      <div class="tasks-title-box my-5 w-100 rounded">
        <v-row class="text-center " >
          <v-col>
            <v-btn v-if="$GLOBAL_DATA.user['degree'] >= 2" class="elevation-0" @click="$emit('create_task')">
              <v-icon small>mdi-plus</v-icon>
              <div >افزودن</div>
            </v-btn>
          </v-col>
          <v-col
              v-if="$GLOBAL_DATA.user['is_superuser'] && $GLOBAL_DATA.user['degree'] === 4"
          >
            <v-btn
                id="menu-activator"
                class="elevation-0"
            >
              مدیریت
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
            <v-menu activator="#menu-activator">
              <v-list>
                <v-list-item
                    v-for="(item, index) in manage_items"
                    :key="index"
                    :value="index"
                    color="#D20003"
                    @click="$emit('manage', item)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

          </v-col>
          <v-col  >
            <v-btn v-if="$GLOBAL_DATA.user['degree'] > 2" class="elevation-0" @click="$emit('ListDevices_show')">
              <v-icon small>mdi-view-headline</v-icon>
              <div>تجهیزات</div>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn v-if="$GLOBAL_DATA.user['degree'] >= 2 " class="elevation-0"
                   :loading="loading_reports_pdf"
                   @click="$emit('get_report')"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_447_3963)">
                  <path d="M22.41 8.41L17.58 3.58C17.21 3.21 16.7 3 16.17 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H21C22.1 21 23 20.1 23 19V9.83C23 9.3 22.79 8.79 22.41 8.41ZM9 7H16V9H9V7ZM19 17H9V15H19V17ZM19 13H9V11H19V13Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0_447_3963">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <div >گزارش گیری</div>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="elevation-0" outlined color="red"
                   @click="filtered=false;$emit('clear');" v-if="filtered"
                   >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 17.6325H14V15.6734H10V17.6325ZM3 5.87744V7.83663H21V5.87744H3ZM6 12.7346H18V10.7754H6V12.7346Z" fill="red"/>
              </svg>
              <div>حذف فیلتر</div>
            </v-btn>
            <v-btn class="elevation-0" outlined
                   v-else
                   @click="show_s_filter=true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 17.6325H14V15.6734H10V17.6325ZM3 5.87744V7.83663H21V5.87744H3ZM6 12.7346H18V10.7754H6V12.7346Z" fill="black"/>
              </svg>
              <div>فیلتر پیشرفته</div>
            </v-btn>

          </v-col>
        </v-row>
      </div>

      <TaskSpecialFilter @close="show_s_filter=false;" :show_s_filter="show_s_filter" @filter_by="filter"></TaskSpecialFilter>
    </div>
  </template>

  <script>
  import SearchByDate from "@/components/admin/tasks/search-by-date.vue";
  import TaskSpecialFilter from "@/components/admin/tasks/tasks-special-filter.vue";
  export default {
    name: "TaskNav",
    components:{TaskSpecialFilter, SearchByDate},
    props:['tasks_count'],
    data:()=>({
      search_tasks: null,
      loading_reports_csv:false,
      loading_reports_pdf:false,
      show_s_filter:false,
      filtered:false,
      rules: {
        min_3: v => v.length >= 3 || 'حداقل ۳ حرف',
      },
      manage_items: [
        {title: 'مکان ها', model:'locations'},
        {title: 'تگ ها', model:'tags'},
        {title: 'دسته‌بندی', model:'categories'}
      ]
    }),
    created(){
    },
    methods: {
      filter(filter_by){
        this.filtered = true;
        this.$emit('filter', filter_by)
      },
      download_reports(url, f_name) {
        // if(f_name === 'tasks.pdf') this.loading_reports_pdf = true;
        // else this.loading_reports_csv = true;
        if(this.s_filter.filtered || this.search_by_date.is_searched || this.search_tasks_loaded){
          alert(1);
        }

        // axios.get(url, { responseType: 'blob' })
        //     .then(response => {
        //       const blob = new Blob([response.data], { type: `application/${f_name === 'tasks.pdf'?'pdf':'csv'}` })
        //       const link = document.createElement('a')
        //       link.href = URL.createObjectURL(blob)
        //       link.download = f_name
        //       link.click()
        //       URL.revokeObjectURL(link.href)
        //       this.$snotify.success( 'فایل گزارشات با موفقیت دانلود شد.','فایل گزارشات',)
        //     })
        //     .catch((errors)=>{
        //       console.log(errors);
        //       this.$snotify.error( 'مشکلی در دانلود فایل ','فایل گزارشات',)

        //     })
        //     .finally(()=>{
        //       if(f_name === 'tasks.pdf') this.loading_reports_pdf = false;
        //       else this.loading_reports_csv = false;
        //     })
      },

    }
  }
  </script>
